<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="text-center mb-2">Order Management Platform</h1>
          <h2 class="text-center">
            Complete Ordering, Delivery, Pickup, and Tracking Platform
            Customized to Your Specific Needs.
          </h2>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-sm-4">
          <h3 class="text-center title">
            <strong>1. Order from your website or over the phone</strong>
          </h3>
          <div>
            <v-img src="/img/delivery/order-online.jpg"></v-img>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <h3 class="text-center title">
            <strong>
              2. Your driver can accept the delivery from the mobile app or you
              can assign them
            </strong>
          </h3>
          <div>
            <v-img src="/img/delivery/take-order.jpg"></v-img>
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <h3 class="text-center title">
            <strong>
              3. Track your drivers and orders from the dispatch center
              dashboard
            </strong>
          </h3>
          <div>
            <v-img src="/img/delivery/dispatch.jpg"></v-img>
          </div>
        </div>
      </div>
      <div class="row mt-5">
        <div class="col-12">
          <h2 class="text-center">
            We are with you every step of the way to ensure your customer's
            happiness with every order.
          </h2>
        </div>
      </div>
    </div>

    <div class="row mt-sm-5 pb-5 mb-5">
      <v-col cols="12" class="pa-2 pa-sm-9 mt-12 bg-dark">
        <div class="display-1 text-center mb-0 mt-5">
          Request A Custom Quote Or Schedule a Demo
        </div>
        <div class="upscribe-embed" data-src="https://upscri.be/rtlmez"></div>
      </v-col>
    </div>
    <div class="row mt-sm-5 pb-5 mb-5">
      <v-col cols="12" class="pa-2 pa-sm-9 mt-12 bg-dark">
        <div class="display-1 text-center mb-0 mt-5">
          Questions? Give us a call
          <strong>
            <a href="tel:‪1-720-634-5985‬">‪(720) 634-5985‬</a>
          </strong>
        </div>
      </v-col>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
.title {
  height: 100px;
}
.bg-dark {
  background-color: var(--v-grey-darken3);
  color: white;
  .display-1 {
    color: var(--v-primary-base);
  }
}
</style>
